import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

export const PALETTE = ["#149B9E", "#FFC20E", "#FF6B6B", "#8B5CF6", "#3B82F6", "#22C55E"];

// Native <details> so answers are in the HTML for crawlers; matches the FAQPage JSON-LD built from the same data.
export const Faq = ({ items, title = "Frequently asked questions", intro, testId = "faq-section", colorful = false }) => (
  <section className={`border-t border-black/10 bg-white py-20 lg:py-28 ${colorful ? "dot-grid" : ""}`} data-testid={testId}>
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <SectionHeading eyebrow="FAQ" title={title} intro={intro} />
      <div className={`mt-10 ${colorful ? "space-y-3" : "divide-y divide-black/10 rounded-2xl border border-black/10 bg-white"}`}>
        {items.map((f, i) => (
          <Reveal key={f.q} delay={0.04 * i}>
            <details data-testid={`faq-item-${i}`} className={`faq-item group px-6 py-5 open:bg-en-teal/[0.03] ${colorful ? "rounded-xl border border-black/10 bg-white shadow-sm" : ""}`} style={colorful ? { borderLeft: `4px solid ${PALETTE[i % PALETTE.length]}` } : undefined}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left font-display text-lg text-black marker:content-none sm:text-xl">
                <h3 className="font-display text-lg sm:text-xl">{f.q}</h3>
                <Plus className="h-5 w-5 shrink-0 transition-transform duration-300 group-open:rotate-45" style={{ color: colorful ? PALETTE[i % PALETTE.length] : "#149B9E" }} />
              </summary>
              <div className="faq-body"><p className="mt-3 max-w-3xl text-sm leading-relaxed text-black/70 sm:text-base">{f.a}</p></div>
            </details>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
